import React, { useEffect, useState } from "react"
import {  CheckBox, DateBox, SelectBox, TextArea, TextBox} from 'devextreme-react';
import { useDispatch, useSelector } from "react-redux";
import { deleteStrangeCharacters } from "../../../../../commonFunctions/commonFunctions";
import { getTaxonomyTemplates } from "../../../../../redux/factoryProcessTemplates/thunks";
import { selectTaxonomyTemplates, selectTaxonomyTemplatesLoading } from "../../../../../redux/factoryProcessTemplates/selectors";
import dayjs from "dayjs";
import { getProvinces } from "../../../../../redux/provinces/thunks";
import { selectProvinces } from "../../../../../redux/provinces/selectors";
import { baseRequest } from "../../../../../fetch/basicThunk";
import { QUERY_GET_EMAIL_FROM_TEMPLATE } from "../../../../../fetch/constantQueries";
import { EmailCodeTemplates } from "../../../../../Constantes/emailCodeTemplates";

function InputWrapper(props){
const {classes, label} = props;
    return(
        <div className="dx-field">
        <label className={classes.label}>{label}</label> 
            <div style={{width:"100%"}} className="dx-field-value">
                {props.children}
            </div>
    </div>
    )
}

function MarshForm(props){
const {classes, onChange, dataForm, template} = props;
const dispatch = useDispatch();
const types = useSelector(selectTaxonomyTemplates);
const [type, setType] = useState(dataForm?.templateCode);
const provinces = useSelector(selectProvinces);
const selectOptions = ["Sí", "No"]

useEffect(()=>{

    dispatch(getTaxonomyTemplates({query: "?templateCode=" + template?.code}))
    dispatch(getProvinces());
    if(types && types.length === 1){
        onChange("templateId", types[0].id);
        onChange("templateCode", types[0].code)
        setType(types[0].id);
    }
    loadRecipients();

    return ()=> onChange("emails", "")
},[])

async function loadRecipients(){
    const recipientData = await baseRequest({query:`?templateCode=${EmailCodeTemplates.OUT_OF_TIME_SINISTER}`}, dispatch, QUERY_GET_EMAIL_FROM_TEMPLATE, "POST")
 
    if(recipientData.value.length > 0){
        let resultToString = recipientData.value.filter(emailRecipient =>{return !emailRecipient.isCC;}).map(emailRecipient => emailRecipient.emailAddress).join("; ")
        const ccEmails = recipientData.value.filter(emailRecipient =>{return emailRecipient.isCC;}).map(emailRecipient => emailRecipient.emailAddress).join("; ")
        if(ccEmails?.length > 0) resultToString += `;${ccEmails}`;
        onChange("emails", resultToString);
      }
}

useEffect(()=>{
    if(types.length === 1){
        onChange("templateId", types[0].id);
        onChange("templateCode", types[0].code)
        setType(types[0].id);
    }
},[types])

function changeDate(field, date){
    let stringDate = null; 
    if(date){
    stringDate = dayjs(date).format()
    }
    onChange(field,stringDate)
}

function setNotes(e){
    const filteredText = deleteStrangeCharacters(e.value); 
    onChange("notes", filteredText)
   
}

function setPhoneNumber(e){
    let nonDigitsRegExp = /\D/gm;
    const filteredNumber = e.value.replace(nonDigitsRegExp, "")
    onChange("phoneNumber", filteredNumber)
}

    return(
        <div className={classes.containers} id="documentation-request-form">
                    <InputWrapper classes={classes} label={"Dirección"}>
                        <TextBox key={"address"} name="address" value={dataForm?.address} onValueChanged={(e) => onChange("address",e.value)} className={classes.controlers} height={25}></TextBox>
                    </InputWrapper> 
                    <InputWrapper classes={classes} label={"Provincia"}>
                        <SelectBox placeholder=" " key={"province"} name="province" value={dataForm?.province} dataSource={provinces} onValueChanged={(e) => onChange("province", e.value)} className={classes.controlers} height={25} style={{marginTop: 0}}></SelectBox>
                    </InputWrapper>        
                    <InputWrapper classes={classes} label={"Daños en el vh"}>
                        <TextBox key={"damage"} name="damage" value={dataForm?.damage} onValueChanged={(e) => onChange("damage",e.value)} className={classes.controlers} height={25}></TextBox>
                    </InputWrapper>
                    <InputWrapper classes={classes} label={"Quiere reparar?"}>
                        <SelectBox placeholder=" " key={"wantToRepair"} name="wantToRepair" dataSource={selectOptions} value={dataForm?.wantToRepair} onValueChanged={(e) => onChange("wantToRepair",e.value)} className={classes.controlers} height={25}></SelectBox>
                    </InputWrapper>
                    <InputWrapper classes={classes} label={"Fecha y hora"}>
                        <DateBox displayFormat={"dd/MM/yyyy HH:mm"} applyButtonText="Aceptar" cancelButtonText="Cancelar" key={"date"} name="date" type="datetime" value={dataForm?.date} onValueChanged={(e) => changeDate("date", e.value)} className={classes.controlers} height={25}></DateBox>
                    </InputWrapper>
                <div className={classes.input_grid}>
                    <InputWrapper classes={classes} label={"Lesiones"}>
                        <SelectBox placeholder=" " key={"injury"} name="injury" dataSource={selectOptions} value={dataForm?.injury} onValueChanged={(e) => onChange("injury",e.value)} className={classes.controlers} height={25}></SelectBox>
                    </InputWrapper>
                    <InputWrapper classes={classes} label={"Atestado"}>
                        <SelectBox placeholder=" " key={"report"} name="report" dataSource={selectOptions} value={dataForm?.report} onValueChanged={(e) => onChange("report",e.value)} className={classes.controlers} height={25}></SelectBox>
                    </InputWrapper>
                </div>
                    <InputWrapper classes={classes} label={"Grúa"}>
                        <SelectBox placeholder=" " key={"towTruck"} name="towTruck" dataSource={selectOptions} value={dataForm?.towTruck} onValueChanged={(e) => onChange("towTruck",e.value)} className={classes.controlers} height={25}></SelectBox>
                    </InputWrapper>
                    <InputWrapper classes={classes} label={"Declaración amistosa"}>
                        <SelectBox placeholder=" " key={"amicableDeclaration"} name="amicableDeclaration" dataSource={selectOptions} value={dataForm?.amicableDeclaration} onValueChanged={(e) => onChange("amicableDeclaration",e.value)} className={classes.controlers} height={25}></SelectBox>
                    </InputWrapper>                                  
                <div className={classes.input_grid}>
                    <InputWrapper classes={classes} label={"Nombre"}>
                        <TextBox key={"name"} name="name" value={dataForm?.name} onValueChanged={(e) => onChange("name",e.value)} className={classes.controlers} height={25}></TextBox>
                    </InputWrapper>
                    <InputWrapper classes={classes} label={"Apellidos"}>
                        <TextBox key={"surname"} name="surname" value={dataForm?.surname} onValueChanged={(e) => onChange("surname",e.value)} className={classes.controlers} height={25}></TextBox>
                    </InputWrapper>
                </div>
                <div className={classes.input_grid} style={{marginBottom: "10px"}}>                           
                    <InputWrapper classes={classes} label={"Móvil"}>
                        <TextBox key={"phoneNumber"} maxLength={9} name="phoneNumber" value={dataForm?.phoneNumber} onValueChanged={(e) =>{setPhoneNumber(e)}} className={classes.controlers} height={25}></TextBox>
                    </InputWrapper>   
                    <InputWrapper classes={classes} label={"Correo electrónico"}>
                            <TextBox key={"email"} name="email" value={dataForm?.email} onValueChanged={(e) => onChange("email",e.value)} className={classes.controlers} height={25}></TextBox>
                    </InputWrapper>                                    
                </div>
                <div className={classes.label} style={{fontSize: "14px", marginBottom: "10px" }}>{"Vehículo contrario"}</div> 
                <div className={classes.input_grid} style={{marginBottom: "10px"}}>       
                <InputWrapper classes={classes} label={"Matrícula"}>
                    <TextBox key={"otherPlate"} name="otherPlate" value={dataForm?.otherPlate} onValueChanged={(e) => onChange("otherPlate",e.value)} className={classes.controlers} height={25}></TextBox>
                </InputWrapper>
                <InputWrapper classes={classes} label={"Marca"}>
                    <TextBox key={"otherBrand"} name="otherBrand" value={dataForm?.otherBrand} onValueChanged={(e) => onChange("otherBrand",e.value)} className={classes.controlers} height={25}></TextBox>
                </InputWrapper>
                </div>
                <InputWrapper classes={classes} label={"Modelo"}>
                    <TextBox key={"otherModel"} name="otherModel" value={dataForm?.otherModel} onValueChanged={(e) => onChange("otherModel",e.value)} className={classes.controlers} height={25}></TextBox>
                </InputWrapper>
                <InputWrapper classes={classes} label={"Compañía de seguros"}>
                    <TextBox key={"otherInsurance"} name="otherInsurance" value={dataForm?.otherInsurance} onValueChanged={(e) => onChange("otherInsurance",e.value)} className={classes.controlers} height={25}></TextBox>
                </InputWrapper>
                <div className={classes.input_grid}>
                    <InputWrapper classes={classes} label={"Nombre"}>
                        <TextBox key={"otherName"} name="otherName" value={dataForm?.otherName} onValueChanged={(e) => onChange("otherName",e.value)} className={classes.controlers} height={25}></TextBox>
                    </InputWrapper>
                    <InputWrapper classes={classes} label={"Apellidos"}>
                        <TextBox key={"otherSurname"} name="otherSurname" value={dataForm?.otherSurname} onValueChanged={(e) => onChange("otherSurname",e.value)} className={classes.controlers} height={25}></TextBox>
                    </InputWrapper>
                </div>
                <InputWrapper classes={classes} label={"Daños del vh"}>
                        <TextBox key={"otherDamage"} name="otherDamage" value={dataForm?.otherDamage} onValueChanged={(e) => onChange("otherDamage",e.value)} className={classes.controlers} height={25}></TextBox>
                </InputWrapper>         
                <InputWrapper classes={classes} label={"Versión de lo ocurrido"}>
                    <TextArea key={"notes"} name="notes" value={dataForm?.notes} onValueChanged={(e) => setNotes(e)} className={classes.controlers} height={60}></TextArea>
                </InputWrapper>
                <div className={classes.input_grid}>
                    <InputWrapper classes={classes} label="Enviar email">
                        <CheckBox value={dataForm?.sendMail} onValueChanged={(e) => onChange("sendMail", e.value)} className={classes.controlers}  height={25} style={{marginTop: 0}}></CheckBox>
                    </InputWrapper>
                </div>
                {dataForm?.sendMail &&
                    <InputWrapper label={"Destinatarios"} classes={classes}>
                                <TextArea maxLength={1000} valueChangeEvent="keyup" onValueChanged={(e)=>onChange("emails" , e.value)} value={dataForm.emails} className={classes.controlers} height={60}></TextArea>
                    </InputWrapper>}
        </div>
    )
}

export { MarshForm }